// Assemble a template body by expanding composition tokens:
//   {{block:ID}}     -> the reusable block's body (from the catalog)
//   {{slider:KEY}}   -> the chosen slider value, else its default, else [KEY]
//
// Blocks are expanded first (a block may contain slider tokens), then sliders.
// A body with no tokens (every existing template) is returned unchanged.
//
// CommonJS so the same function is unit-testable in Node and importable in CRA.

function assembleTemplate(body, options) {
  const opts = options || {};
  const blocks = opts.blocks || [];
  const sliders = opts.sliders || [];
  const sliderValues = opts.sliderValues || {};

  const blockById = {};
  blocks.forEach((b) => {
    blockById[b.id] = b.body;
  });

  const defaults = {};
  sliders.forEach((s) => {
    defaults[s.key] = s.default;
  });

  // 1. Expand block includes.
  let out = String(body).replace(/\{\{block:([a-z0-9-]+)\}\}/gi, (match, id) =>
    Object.prototype.hasOwnProperty.call(blockById, id) ? blockById[id] : match
  );

  // 2. Resolve slider tokens (including any inside the expanded blocks).
  out = out.replace(/\{\{slider:([A-Z0-9_]+)\}\}/gi, (match, key) => {
    if (sliderValues[key]) return sliderValues[key];
    if (defaults[key]) return defaults[key];
    return '[' + key + ']';
  });

  return out;
}

module.exports = { assembleTemplate };
